import * as React from 'react';
import Layout from './layout/layout';
import { DataGrid } from '@mui/x-data-grid';

import moment from '../config/moment.config';
import { IconButton, Toolbar, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';

import ConfirmDialog from '../components/ConfirmDialog';
import useNotification from '../components/notification';
import axios from '../AxiosInstance';
import { routeName } from '../routes/paths';

export default function Blogs() {
  // ----- use somthing -------//
  const navigate = useNavigate();
  const { sendNotification } = useNotification();
  // ----- STATE section -------//
  const [blogs, setBlogs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedBlog, setSelectedBlog] = React.useState({});
  const [openDialog, setOpenDialog] = React.useState(false);

  //------ use EFFECT section -------//
  async function fetchData() {
    axios
      .get(`/blogs?type=1`)
      .then((res) => {
        // console.log(res.data);
        setBlogs(res.data);
        // setFilterProducts(res.data);
        setLoading(false);
        // sendNotification({ msg: `Delete reportId : ${selectedReport.id}`, variant: 'success' });
      })
      .catch((err) => {
        console.error(err.response);
        setLoading(false);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  // ----- METHOD section -------//
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteSubmit = async () => {
    setOpenDialog(false);
    axios
      .delete(`/blogs/${selectedBlog.id}`)
      .then((res) => {
        // console.error(err.response);
        sendNotification({ msg: `Delete blog : ${selectedBlog.title}`, variant: 'success' });
        fetchData();
      })
      .catch((err) => {
        console.error(err.response);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };

  const columns = [
    { field: 'id', headerName: 'id' },
    {
      field: 'featuredImage',
      headerName: 'รูปปก',

      renderCell: (params) => {
        return <img src={params.value} alt='' height={50} width={50} style={{ objectFit: 'cover' }} />;
      },
    },
    {
      field: 'title',
      headerName: 'Title',
      // hide: true,
      width: 350,
    },
    {
      field: 'slug',
      headerName: 'Slug',
      // hide: true,
      width: 250,
    },
    {
      field: 'createdAt',
      headerName: 'createdAt',
      valueFormatter: (params) => {
        return params.value ? moment(params.value).format('ll') : '';
      },
      width: 120,
    },
    {
      field: 'updatedAt',
      headerName: 'updatedAt',
      valueFormatter: (params) => {
        return params.value ? moment(params.value).format('ll') : '';
      },
      width: 120,
    },
    {
      field: 'action',
      disableColumnMenu: true,
      sortable: false,
      headerName: 'Action',
      renderCell: (params) => {
        return (
          <React.Fragment>
            <IconButton
              //   color='warning'
              onClick={() => {
                navigate(`${routeName.BLOGS}/${params.id}`);
              }}>
              <EditIcon />
            </IconButton>
            <IconButton
              color='error'
              onClick={() => {
                // console.log('delete ' + params.id);
                let select_blog = blogs.find((blog) => blog.id === params.id);
                // console.log(selectedCombination);
                setSelectedBlog(select_blog);
                setOpenDialog(true);
                // console.log(select_port);
              }}>
              <DeleteIcon />
            </IconButton>
          </React.Fragment>
        );
      },
      disableClickEventBubbling: true,
    },
  ];

  return (
    <Layout>
      <Toolbar>
        <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
          Blogs
        </Typography>
        <Button startIcon={<AddIcon />} variant='outlined' onClick={() => navigate(`${routeName.BLOGS}/add?type=1`)}>
          Add Blogs
        </Button>
      </Toolbar>

      <DataGrid
        rows={blogs}
        columns={columns}
        // pageSize={10}
        // rowsPerPageOptions={[10]}
        autoHeight
        loading={loading}
        // checkboxSelection
        // sortModel={sortModel}
        // onSortModelChange={(model) => setSortModel(model)}
        disableSelectionOnClick
        // onCellEditCommit={handleCellEditCommit}
      />

      <ConfirmDialog
        title='Delete Blog?'
        content={`Are you sure to delete blog : ${selectedBlog.title}?`}
        submitText='Delete'
        open={openDialog}
        onClose={handleDialogClose}
        onSubmit={handleDeleteSubmit}
      />
    </Layout>
  );
}
